<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<empty-layout *ngIf="layout === 'empty'"></empty-layout>

<ainop-h-layout *ngIf="layout === 'ainop-orizzontale'"></ainop-h-layout>
<ainop-v-layout *ngIf="layout === 'ainop-verticale'"></ainop-v-layout>

<demo-h-layout *ngIf="layout === 'demo-orizzontale'"></demo-h-layout>
<demo-v-layout *ngIf="layout === 'demo-verticale'"></demo-v-layout>

<prova-v-layout *ngIf="layout === 'prova-verticale'"></prova-v-layout>

<spezia-h-layout *ngIf="layout === 'spezia-orizzontale'"></spezia-h-layout>
<spezia-v-layout *ngIf="layout === 'spezia-verticale'"></spezia-v-layout>

<sanlazzaro-h-layout *ngIf="layout === 'sanlazzaro-orizzontale'"></sanlazzaro-h-layout>
<sanlazzaro-v-layout *ngIf="layout === 'sanlazzaro-verticale'"></sanlazzaro-v-layout>

<rapallo-h-layout *ngIf="layout === 'rapallo-orizzontale'"></rapallo-h-layout>

<pratica-layout *ngIf="layout === 'pratica'"></pratica-layout>


<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with horizontal navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Centered -->
<centered-layout *ngIf="layout === 'centered'"></centered-layout>

<!-- Enterprise -->
<enterprise-layout *ngIf="layout === 'enterprise'"></enterprise-layout>

<!-- Material -->
<material-layout *ngIf="layout === 'material'"></material-layout>

<!-- Modern -->
<modern-layout *ngIf="layout === 'modern'"></modern-layout>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with vertical navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Classic -->
<classic-layout *ngIf="layout === 'classic'"></classic-layout>

<!-- Classy -->
<classy-layout *ngIf="layout === 'classy'"></classy-layout>

<!-- Compact -->
<compact-layout *ngIf="layout === 'compact'"></compact-layout>

<!-- Dense -->
<dense-layout *ngIf="layout === 'dense'"></dense-layout>

<!-- Futuristic -->
<futuristic-layout *ngIf="layout === 'futuristic'"></futuristic-layout>

<!-- Thin -->
<thin-layout *ngIf="layout === 'thin'"></thin-layout>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Settings drawer - Remove this to remove the drawer and its button -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- <settings></settings> -->
